/**
 * Horizontal swipe → chapter navigation for the Bible reader.
 * Mostly-vertical drags (normal reading scrolls) never trigger it.
 */

interface SwipeCallbacks {
  onPrev: () => void;
  onNext: () => void;
}

const MIN_SWIPE_X = 70;
const HORIZONTAL_DOMINANCE = 2;

/** Attach swipe chapter navigation to the reader container. Returns a cleanup fn. */
export function attachSwipeNavigation(el: HTMLElement, callbacks: SwipeCallbacks): () => void {
  let startX = 0;
  let startY = 0;
  let isTracking = false;

  const onTouchStart = (e: TouchEvent) => {
    if (e.touches.length !== 1) {
      isTracking = false;
      return;
    }
    isTracking = true;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  };

  const onTouchEnd = (e: TouchEvent) => {
    if (!isTracking) return;
    isTracking = false;
    const touch = e.changedTouches[0];
    if (!touch) return;

    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;
    if (Math.abs(dx) < MIN_SWIPE_X) return;
    if (Math.abs(dx) < HORIZONTAL_DOMINANCE * Math.abs(dy)) return;

    if (dx < 0) callbacks.onNext();
    else callbacks.onPrev();
  };

  el.addEventListener('touchstart', onTouchStart, { passive: true });
  el.addEventListener('touchend', onTouchEnd, { passive: true });
  return () => {
    el.removeEventListener('touchstart', onTouchStart);
    el.removeEventListener('touchend', onTouchEnd);
  };
}
